import { createSlice } from '@reduxjs/toolkit'

import { exportSelectors } from '../selectors/export'

const initialState = {
    isExporting: false,
    notice: null,
    error: null,
}

const exportSlice = createSlice({
    name: 'export',
    initialState,
    reducers: {
        setExporting: (state, action) => {
            state.isExporting = action.payload
        },
        setNotice: (state, action) => {
            state.notice = action.payload
            state.error = null
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        resetNotice: (state) => {
            state.notice = null
        },
    },
    selectors: {
        ...exportSelectors,
    },
})

export const exportSelector = exportSlice.getSelectors()
export const exportActions = exportSlice.actions

export default exportSlice.reducer
